import Vue from 'vue'
import Vuex from 'vuex'
import storage from '@/utils/storage'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    source: storage.getItem('source') || '',
    token: storage.getItem('token') || '',
    menus: storage.getItem('menus') || [],
    btnList: storage.getItem('btn') || {},
    itCode: storage.getItem('itCode') || '',
    username: storage.getItem('username') || '',
    // customer management => customer basic profile 默认是否显示 form 表单
    basicShowForm: false,
    // bureauReport 详情基本信息
    bureauReportBasicInfo: storage.getItem('bureauReportBasicInfo') || {},
    customerType: '',
    customerTypeList: [],
  },
  mutations: {
    setToken(state, token) {
      state.token = token
    },
    setSource(state, source) {
      state.source = source
    },
    setMenus(state, menus) {
      state.menus = menus
    },
    setUsername(state, username) {
      state.username = username
    },
    setItcode(state, itCode) {
      state.itCode = itCode
    },
    setBtnPermissionList(state, btn) {
      state.btnList = btn
    },
    setBasicShowForm(state, tag) {
      state.basicShowForm = tag
    },
    clearAllStore(state) {
      state.token = ''
      state.source = ''
      state.menus = []
      state.itCode = ''
      state.btnList = {}
      state.username = ''
      state.basicShowForm = false
      storage.clearAll()
    },
    setBureauReportBasicInfo(state, payload) {
      state.bureauReportBasicInfo = payload
    },
    SET_CUSTOMER_TYPE(state, type) {
      state.customerType = type
    },
    setCustomerTypeList(state, list) {
      state.customerTypeList = list
    },
  },
  actions: {},
  modules: {},
})

store.subscribe(({ type, payload }) => {
  switch (type) {
    case 'setMenus':
      storage.setItem('menus', payload)
      break
    case 'setSource':
      storage.setItem('source', payload)
      break
    case 'setUsername':
      storage.setItem('username', payload)
      break
    case 'setItcode':
      storage.setItem('itCode', payload)
      break
    case 'setToken':
      storage.setItem('token', payload)
      break
    case 'setBtnPermissionList':
      storage.setItem('btn', payload)
      break
    case 'setBureauReportBasicInfo':
      storage.setItem('bureauReportBasicInfo', payload)
      break
  }
})

export default store
